import React from "react";
import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import HowItWorks from "../components/HowItWorks";
import Pricing from "../components/Pricing";
import Eligibility from "../components/Eligibility";
import Testimonials from "../components/Testimonials";
import Regulations from "../components/Regulations";
import FAQ from "../components/FAQ";
import AskAI from "../components/AskAI";
import Footer from "../components/Footer";

// Feature flag: set to true to re-enable the patient testimonials section
const SHOW_PATIENT_TESTIMONIALS = false;

const Home = () => {
  return (
    <div className="min-h-screen flex flex-col font-sans">
      <Navbar />
      <main className="flex-grow">
        <Hero />
        <HowItWorks />
        <Pricing />
        <Eligibility />
        {SHOW_PATIENT_TESTIMONIALS && <Testimonials />}
        <Regulations />
        <FAQ />
        <AskAI />
      </main>
      <Footer />
    </div>
  );
};

export default Home;
